import React from "react";
import Introduction from "./Partials/Introduction";
import {getStatusIconByStatus, stripHttps} from "./Support/Helper";
import Icon from "./Support/Icon";
import {EVENT_DETAILS_BUTTON_CLICKED, EVENT_LEAD_CONFIRMED} from "./Support/Events";

const initialState = {
    lead_confirmed: false,
    show_font_details: false
}

export default class ResultHeader extends React.Component {
    constructor(props) {
        super(props);
        this.state = initialState;
        this.googleFontsFound = props.result.hasOwnProperty('google_fonts_found') && props.result.google_fonts_found === true;
        this.otherToolsFound = props.result.hasOwnProperty('other_tools_found') && props.result.other_tools_found === true;
        this.detailsButtonClicked = this.detailsButtonClicked.bind(this);
        this.onLeadConfirmed = this.onLeadConfirmed.bind(this);
    }

    componentDidMount() {
        document.addEventListener(EVENT_LEAD_CONFIRMED, this.onLeadConfirmed);
    }

    detailsButtonClicked() {
        if (this.props.premium || this.state.lead_confirmed) {
            this.setState({
                show_font_details: !this.state.show_font_details
            })
        } else {
            document.dispatchEvent(new CustomEvent(EVENT_DETAILS_BUTTON_CLICKED));
        }
    }

    onLeadConfirmed() {
        this.setState({
            lead_confirmed: true,
            show_font_details: true
        });
    }

    render() {
        if (typeof callbackWebsitescannerFinish === 'function')
            callbackWebsitescannerFinish();

        let lastFontSlug = null;

        return (
            <div aria-label='Resultate Header' className='scanner-header pb-6'>
                <div className='md:container mx-auto xl:max-w-7xl bg-transparent'>
                    <div className='container-inner'>
                        {/*<div className='flex flex-col md:flex-row items-center md:items-start justify-between space-y-6 md:space-x-8 md:space-y-0'>*/}
                        <div className='grid grid-cols-1 md:grid-cols-12 gap-8 py-8 w-full'>
                            <div className='md:col-span-3 lg:col-span-2'>
                                {getIcon(this.props.result)}
                            </div>

                            <div className='md:col-span-9 lg:col-span-7 text-center md:text-left'>
                                <Introduction
                                    prefix={'Ergebnis für ' + stripHttps(this.props.url)}
                                    headline={(this.googleFontsFound || this.otherToolsFound) ? 'Ihre Website ist abmahngefährdet.' : 'Kein Problem gefunden.'}
                                    suffix={this.googleFontsFound
                                        ? `Google Fonts ist <strong>nicht DSGVO-konform</strong> eingebunden.`
                                        : this.otherToolsFound
                                        ? 'Ihre Website enthält Tools, die Google Fonts laden.'
                                        : ''}
                                />
                                {(this.googleFontsFound) && (
                                    <>
                                        {(this.state.show_font_details) && (
                                            <>
                                                <button className="details-button details-button--hide" onClick={this.detailsButtonClicked}>
                                                    <span className="mr-2">Details verbergen</span>
                                                    <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M9.51333 6.48667L10.75 5.25L5.5 0L0.25 5.25L1.48667 6.48667L5.5 2.47333L9.51333 6.48667Z" fill="currentColor"/>
                                                    </svg>
                                                </button>
                                                <div className="scanner-result--details text-left">
                                                    <p>Beim Scan wurden folgende Google Fonts auf der Website gefunden:</p>
                                                    {this.props.result.fonts.map((item, i) => {
                                                        return (
                                                            <ul className={(item.slug === lastFontSlug) ? `!border-t-0 !pt-0` : ''}>
                                                                {(item.slug !== lastFontSlug) && (
                                                                    <li className="!list-none">
                                                                        {(lastFontSlug = item.slug) && null}
                                                                        <strong>{item.name}</strong><br />
                                                                    </li>
                                                                )}
                                                                <li>
                                                                    <a href={item.url} target="_blank">{item.url}</a>
                                                                </li>
                                                            </ul>
                                                        )
                                                    })}
                                                </div>
                                            </>
                                        )}
                                        {(!this.state.show_font_details) && (
                                            <button className="details-button details-button--show" onClick={this.detailsButtonClicked}>
                                                <span className="mr-2">Details anzeigen</span>
                                                <svg width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1.48667 0.513333L0.25 1.75L5.5 7L10.75 1.75L9.51333 0.513333L5.5 4.52667L1.48667 0.513333Z" fill="currentColor"/>
                                                </svg>
                                            </button>
                                        )}
                                    </>
                                )}
                            </div>

                            <div className='md:col-span-12 lg:col-span-3'>
                                <div className='w-48 m-auto'>
                                    <div className="relative">
                                        <svg viewBox="0 0 222 188" fill="none" xmlns="http://www.w3.org/2000/svg"
                                             aria-label="monitor" className="w-full">
                                            <path
                                                d="M9.571 1H212.43A8.56 8.56 0 01221 9.571v136.572a8.56 8.56 0 01-8.571 8.571H9.571A8.56 8.56 0 011 146.143V9.571A8.56 8.56 0 019.571 1z"
                                                fill="#E6E6E6" stroke="#C8C8C8" strokeMiterlimit="10"></path>
                                            <path
                                                d="M138.543 179.057c-1.372-1.657-2.857-14.628-3.886-24.343H87.743c-1.029 9.715-2.457 22.686-3.886 24.343-2.686 3.257-7.486 4.172-7.486 5.372 0 .857.172 1.714 1.772 2.285H144.2c1.6-.571 1.771-1.371 1.771-2.285.057-1.2-4.743-2.115-7.428-5.372z"
                                                fill="#E6E6E6" stroke="#C8C8C8" strokeMiterlimit="10"></path>
                                            <path d="M212.143 10.428H10.429v123.429h201.714V10.429z" fill="#fff"></path>
                                            <path
                                                d="M112.429 5.514c0 .686-.572 1.257-1.2 1.257a1.269 1.269 0 01-1.258-1.257c0-.685.572-1.257 1.258-1.257.685.057 1.2.572 1.2 1.257z"
                                                stroke="#C8C8C8" strokeWidth="0.5" strokeMiterlimit="10"></path>
                                            <path
                                                d="M111.743 5.514a.512.512 0 01-.514.515.513.513 0 01-.515-.515c0-.285.229-.514.515-.514.285 0 .514.229.514.514z"
                                                fill="#C8C8C8"></path>
                                            <path fill="#AEAEAE" d="M10.428 10.428h201.714v16.571H10.428z"></path>
                                            <path fill="#D5D5D5"
                                                  d="M19 34.429h81.714v6.857H19zM103.571 34.429h48v6.857h-48zM19 50.429h43.429v4H19zM65.286 50.428h24.571v4H65.286zM92.714 50.428h58.857v4H92.714zM19 58.429h66.286v4H19zM88.143 58.429h52v4h-52zM19 66.429h21.714v4H19zM43.571 66.429h52v4h-52zM98.428 66.429h53.143v4H98.428zM19 105.286h60.276v4H19zM83.242 105.286h34.103v4H83.242zM121.31 105.286H203v4h-81.69zM19 113.286h92v4H19zM114.965 113.286h72.172v4h-72.172zM19 121.286h30.138v4H19zM53.103 121.286h72.172v4H53.103zM129.241 121.286H203v4h-73.759zM19 81.857h43.429v4H19zM65.286 81.857h24.571v4H65.286zM92.714 81.857h58.857v4H92.714zM19 89.857h66.286v4H19zM88.143 89.857h52v4h-52z"></path>
                                            <path fill="#D4D4D4"
                                                  d="M160.714 50.429H203v43.429h-42.286zM19 14.429h36V23H19z"></path>
                                        </svg>
                                        <div
                                            aria-label='Screenshot'
                                            className='bg-white bg-cover bg-no-repeat bg-top absolute'
                                            style={{
                                                backgroundImage: `url('${this.props.apiBase}/api/screenshot/${this.props.result.scan_id}')`,
                                                height: '106px',
                                                width: '176px',
                                                top: '9px',
                                                left: '8px'
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function getIcon(result) {
    return (
        <div className='scanner-header--icon'>
            <Icon
                type={getStatusIconByStatus((result.google_fonts_found || result.other_tools_found) ? 0 : 2)}
                css='h-full mx-auto'
            />
        </div>
    )
}
